import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme as themeConfig } from "../../themes/themes";
export const ContentTableList = styled.div`
  grid-column: 1/4;
  margin: 0 4.5em;
  .MuiPaper-elevation2 {
    box-shadow: none;
    margin: 1em 0;
  }
  .MuiToolbar-regular {
    min-height: 0px;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[700]};
    padding: 5px 16px;
  }
`;

export const ContentLoader = styled.div`
  grid-column: 1/4;
  display: flex;
  text-align: center;
  height: 69vh;
  align-items: center;
`;

export const ContentPagination = styled.div`
  p {
    margin-top: inherit;
    margin-bottom: inherit;
  }
`;

export const useStyles = makeStyles(() => ({
  delete: {
    color: themeConfig.status.error,
  },
}));
